
import cx from 'classnames'
import _ from '@/utils/lodash-optimized'
import PropTypes from 'prop-types'

import './styles.scss'

export function Card2 ({
  children,
  title,
  subtitle,
  label,
  cardTextColor,
  actions
}) {
  const cardClass = cx({
    'nh-card2': true,
    'green': cardTextColor === 'green',
    'orange': cardTextColor === 'orange',
    'red': cardTextColor === 'red'
  })

  return (
    <article className={cardClass}>
      {title && <h2 className='card-title'>{title}</h2>}
      {subtitle && <h3 className='card-subtitle'>{subtitle}</h3>}
      {label && <h1 className='card-label'>{label}</h1>}
      {children}
      <div className='card-actions'>
        {(actions || []).map((action, index) =>
          (
            _.isEmpty(action)
              ? (

                <button
                  key={`action ${index}`}
                  disabled
                />
              )
              : (
                <button
                  key={`action ${index}`}
                  onClick={action.callback}
                >
                  {action.label}
                </button>
              )
          ))}
      </div>
    </article>
  )
}

Card2.defaultProps = {
  cardTextColor: 'green'
}

Card2.propTypes = {
  children: PropTypes.node,
  cardTextColor: PropTypes.oneOf([ 'green', 'red', 'orange' ]),
  title: PropTypes.oneOfType([ PropTypes.string, PropTypes.element ]),
  subtitle: PropTypes.string,
  label: PropTypes.oneOfType([ PropTypes.string, PropTypes.element ]),
  actions: PropTypes.arrayOf(PropTypes.instanceOf(Object))
}
